import React, { useState } from "react";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/authService";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState({
    newPass: false,
    confirmPass: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await changePassword(currentPassword, newPassword, confirmPassword);
      navigate("/login");
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to reset password. Please try again.");
    }
  };

  return (
    <section className="login-section-bg">
      <div className="container-main">
        <div className="d-flex justify-content-center mb-2">
          <div className="auth-logo">
            <img
              src={images.logoHorizontal}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mt-2">
          <h3 className=" text-center text-primary mb-1 fw-semibold fs-20">
            Back in Control
          </h3>
          <p className="mb-3 text-muted text-center fs-15">
            Log in with the new password once it's set.
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                OTP
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="form-control input-tags"
                placeholder="Enter OTP"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">
                New Password
                <span className="text-danger"> *</span>
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword.newPass ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Enter new password"
                />
                <span
                  className="eye-icon"
                  onClick={() =>
                    setShowPassword((prev) => ({ ...prev, newPass: !prev.newPass }))
                  }
                >
                  <i className={`fa-solid ${showPassword.newPass ? "fa-eye-slash" : "fa-eye"}`}></i>
                </span>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label">
                Confirm Password
                <span className="text-danger"> *</span>
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword.confirmPass ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Re-enter password"
                />
                <span
                  className="eye-icon"
                  onClick={() =>
                    setShowPassword((prev) => ({ ...prev, confirmPass: !prev.confirmPass }))
                  }
                >
                  <i className={`fa-solid ${showPassword.confirmPass ? "fa-eye-slash" : "fa-eye"}`}></i>
                </span>
              </div>
            </div>

            {error && <p className="text-danger fs-13 mt-2 mb-0">{error}</p>}

            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary w-100 mt-1">
                Set Password
              </button>
            </div>
          </form>
          <p className="text-center mb-0 text-muted fs-13 mt-3">
            Back to{" "}
            <a href="/" className="link text-primary text-decoration-underline">
              Sign in
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
